export enum DraggableTypes {
  Item = 'item',
  Section = 'section',
  FlexSection = 'flexSection',
  Page = 'page',
  Slide = 'slide',
  Question = 'question',
  UniqueItem = 'uniqueItem',
  FullPageItem = 'fullPageItem'
}
